import { RegularButton } from 'pg-ui-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  NavTextLink,
  ArrowBack,
  CardItemContainer,
  CardHeaderWithButton,
  ActionsContainer,
  CardContent,
} from './styles';

import QleNewHireEnrollmentTable from '../qle-new-hire-enrollment-table';
import { QleNewHireEnrollmentModal } from '../qle-new-hire-enrollment-modal';

const QleNewHireEnrollment: React.FC = () => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const handleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  const { t } = useTranslation();

  const { isFetching, data } = useQuery(['benefits/qle-new-hire/price-setup'], async () => {
    const result = await BenefitsService.getBenefitQleNewHirePriceSetup();
    return result;
  });
  const result = data ? [data] : [];

  return (
    <Container>
      <Header>
        <HeaderItemLeft>
          <NavTextLink to="/benefits">
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <HeaderTitle>{t('benefits.qleNewHireEnrollment.title')}</HeaderTitle>
        </HeaderItemLeft>
      </Header>
      <Content>
        <CardItemContainer>
          <CardHeaderWithButton>
            <ActionsContainer>
              <RegularButton onClick={handleModal} disabled={isFetching}>
                {t('benefits.qleNewHireEnrollment.addButton')}
              </RegularButton>
            </ActionsContainer>
          </CardHeaderWithButton>
          <CardContent>
            <QleNewHireEnrollmentTable data={result} isFetching={isFetching} />
          </CardContent>
        </CardItemContainer>
      </Content>
      <QleNewHireEnrollmentModal data={data} isOpen={modalIsOpen} handleModal={handleModal} />
    </Container>
  );
};

export default QleNewHireEnrollment;
